import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { RocketLaunch } from "@mui/icons-material";

const TEAL = "#00a6b2";
const MUTED = "#8a94a6";

// Generic gate shown in place of an in-progress customer-facing feature
// while its SystemSettings.featureFlags.<x>Enabled toggle is off — see
// AppRouter's FeatureGate. Admins are never routed here; only the
// customer portal is gated.
const ComingSoon = ({ title, description }) => (
  <Box sx={{ display: "flex", justifyContent: "center", py: { xs: 6, sm: 10 } }}>
    <Card sx={{ p: 5, maxWidth: 440, textAlign: "center", borderRadius: 3 }}>
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          bgcolor: "rgba(0,166,178,0.12)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 2.5,
        }}
      >
        <RocketLaunch sx={{ fontSize: 30, color: TEAL }} />
      </Box>
      <Typography variant="h5" fontWeight={700} sx={{ color: "text.primary", mb: 1 }}>
        {title} — Coming Soon
      </Typography>
      <Typography variant="body2" sx={{ color: MUTED }}>
        {description || "We're putting the finishing touches on this. Check back soon!"}
      </Typography>
    </Card>
  </Box>
);

export default ComingSoon;
